import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
let PropertyTableColumnMappingService = class PropertyTableColumnMappingService {
    propertyTableColumnMap = new BehaviorSubject(null);
    propertyTableColumnMapObservable = this.propertyTableColumnMap.asObservable();
    propertyTableItems = new BehaviorSubject(null);
    propertyTableItemsObservable = this.propertyTableItems.asObservable();
    createApplication = new BehaviorSubject(null);
    createApplicationObservable = this.createApplication.asObservable();
    constructor() {
    }
    setPropertyTableColumnMap(tableColumnMap) {
        this.propertyTableColumnMap.next(tableColumnMap);
    }
    setPropertyTableItems(tableItems) {
        this.propertyTableItems.next(tableItems);
    }
    createApplicationRequest(property) {
        this.createApplication.next(property);
    }
    static ctorParameters = () => [];
};
PropertyTableColumnMappingService = __decorate([
    Injectable({
        providedIn: "root"
    })
], PropertyTableColumnMappingService);
export { PropertyTableColumnMappingService };
